import { useScrollBottom } from 'hooks/useScrollToBottom';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  RadioContainer,
  AnswerBlock,
  Container,
  CurrentQuestionText,
  RadioBox,
  StyledCheckBox,
  CheckboxItem,
  CheckboxText,
  TextArea,
} from './styled';

export const RadioStep = ({
  currentQuestion,
  generateAnswersObject,
  answerItem,
}) => {
  const OtherType = 'Other';
  const [showTextField, setShowTextField] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState('');

  const [scrollElementRef, scrollToBottom] = useScrollBottom();

  const handleInputChange = (e) => {
    let selectedValue = '';
    if (e.target.value === OtherType && textFieldValue !== '') {
      selectedValue = OtherType + ': ' + textFieldValue;
    } else if (e.target.value === OtherType && textFieldValue === '') {
      selectedValue = '';
    } else {
      selectedValue = e.target.value;
    }

    generateAnswersObject({
      position: currentQuestion.position,
      question: currentQuestion.question,
      selectedAnswers: selectedValue !== '' ? [selectedValue] : '',
    });

    if (e.target.value === OtherType) {
      setShowTextField(true);
      scrollToBottom();
    } else {
      setShowTextField(false);
    }
  };

  const onChangeInput = (e) => {
    setTextFieldValue(e.target.value);
    generateAnswersObject({
      position: currentQuestion.position,
      question: currentQuestion.question,
      selectedAnswers: e.target.value ? [OtherType + ': ' + textFieldValue] : '',
    });
  };

  useEffect(() => {
    const OtherTypeValue = answerItem?.selectedAnswers?.filter((elem) =>
      elem.includes(OtherType),
    );

    if (OtherTypeValue?.length) {
      setShowTextField(true);
      setTextFieldValue(OtherTypeValue[0].split(': ')?.[1]);
    } else {
      setShowTextField(false);
      setTextFieldValue('');
    }
  }, [currentQuestion?.position]);

  return (
    <RadioContainer>
      <Container>
        <CurrentQuestionText>{currentQuestion.question}</CurrentQuestionText>
        <RadioBox ref={scrollElementRef}>
          {currentQuestion.answer.map((item) => (
            <AnswerBlock key={uuid()}>
              <CheckboxItem>
                <StyledCheckBox
                  checked={answerItem?.selectedAnswers?.includes(item.value)}
                  value={item.value}
                  name="radioButton"
                  onChange={handleInputChange}
                  type="radio"
                  id={uuid()}
                />
              </CheckboxItem>
              <CheckboxText>{item.label}</CheckboxText>
            </AnswerBlock>
          ))}
          {currentQuestion?.is_other_present ? (
            <AnswerBlock key={uuid()}>
              <CheckboxItem>
                <StyledCheckBox
                  checked={
                    answerItem?.selectedAnswers?.[0]?.includes(OtherType) ||
                    showTextField
                  }
                  value={OtherType}
                  name="radioButton"
                  onChange={handleInputChange}
                  type="radio"
                  id={uuid()}
                />
              </CheckboxItem>
              <CheckboxText>Other</CheckboxText>
            </AnswerBlock>
          ) : null}
          {showTextField ? (
            <TextArea
              name="textfield"
              value={textFieldValue}
              onChange={onChangeInput}
            />
          ) : null}
        </RadioBox>
      </Container>
    </RadioContainer>
  );
};
